"use client";
import FyBootstrap from "@/components/rmc/FyBootstrap";
import { useSidebar } from "@/context/SidebarContext";
import AppHeader from "@/layout/AppHeader";
import AppSidebar from "@/layout/AppSidebar";
import Backdrop from "@/layout/Backdrop";
import React, { useEffect } from "react";
import { useRouter } from "next/navigation";

export default function AdminLayout({
  children,
}) {
  const router = useRouter();
  const { isExpanded, isHovered, isMobileOpen } = useSidebar();

  // Dynamic class for main content margin based on sidebar state
  const mainContentMargin = isMobileOpen
    ? "ml-0"
    : isExpanded || isHovered
    ? "lg:ml-[240px]"
    : "lg:ml-[72px]";

  useEffect(() => {
    const checkAuth = () => {
      const token =
        window.localStorage.getItem("access_token") ||
        window.localStorage.getItem("token");
      if (!token) router.replace("/signin");
    };

    checkAuth();
    window.addEventListener("popstate", checkAuth);
    window.addEventListener("storage", checkAuth);
    return () => {
      window.removeEventListener("popstate", checkAuth);
      window.removeEventListener("storage", checkAuth);
    };
  }, [router]);

  return (
    <div className="min-h-screen xl:flex">
      <FyBootstrap />
      {/* Sidebar and Backdrop */}
      <AppSidebar />
      <Backdrop />
      {/* Main Content Area */}
      <div
        className={`flex-1 transition-all  duration-300 ease-in-out ${mainContentMargin}`}
      >
        {/* Header */}
        <AppHeader />
        {/* Page Content */}
        <div className="p-3 mx-auto max-w-(--breakpoint-2xl) md:p-5">{children}</div>
      </div>
    </div>
  );
}
